import o from"./index.module.scss.js";const s=o;export{s as ButtonTheme};
//# sourceMappingURL=index.js.map
